module.exports = __webpack_public_path__ + "static/media/thtplus-banner.1714cd65.jpg";